module.exports = __webpack_public_path__ + "static/media/example_selfie.9050c4e9.jpg";